import { render } from "./TreeLesson.vue?vue&type=template&id=59a97daa&scoped=true"
import script from "./TreeLesson.vue?vue&type=script&lang=js"
export * from "./TreeLesson.vue?vue&type=script&lang=js"

import "./TreeLesson.vue?vue&type=style&index=0&id=59a97daa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a97daa"]])

export default __exports__